import { useQuery } from '@tanstack/react-query';
import { api } from '../../libs/axios';
import { Fatura } from '../../utils/interfaces'; // Sua interface existente

interface UseFaturaDetalhesProps {
  id: string;
}

async function getFaturaDetalhes({ id }: UseFaturaDetalhesProps): Promise<Fatura> {
  const response = await api
    .get(`faturas/${id}`)
    .then((res) => res.data);

  return response.data;
}

export function useFaturaDetalhes({ id }: UseFaturaDetalhesProps) {
  return useQuery({
    queryKey: ['fatura', id],
    queryFn: () => getFaturaDetalhes({ id }),
    retry: false,
    refetchOnWindowFocus: false,
  });
}